import { getItemWithExpiration } from './utils';

const STORAGE_KEY = 'tab_lock_promotion_dismissed';
const CONFIGURED_KEY = 'tab_lock_configured';

function getCenterId(): string {
    try {
        return getItemWithExpiration('authObject')?.centerId || '';
    } catch {}
    return '';
}

function withCenter(key: string): string {
    const centerId = getCenterId();
    return centerId ? `${key}_${centerId}` : key;
}

/** 오늘 이미 툴팁을 본 적 있는지 */
export function hasSeenTabLockPromotion(): boolean {
    const dismissed = localStorage.getItem(withCenter(STORAGE_KEY));
    if (!dismissed) return false;
    const today = new Date().toISOString().slice(0, 10);
    return dismissed === today;
}

/** 오늘 날짜로 "봤음" 표시 */
export function markTabLockPromotionAsSeen(): void {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem(withCenter(STORAGE_KEY), today);
}

/** 이 센터가 탭 잠금 설정을 직접 변경한 적이 있는지 */
export function hasConfiguredTabLock(): boolean {
    return localStorage.getItem(withCenter(CONFIGURED_KEY)) === 'true';
}

/** 탭 잠금 설정을 직접 변경했음을 기록 */
export function markTabLockConfigured(): void {
    localStorage.setItem(withCenter(CONFIGURED_KEY), 'true');
}
